import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48929044562170:1';
const CHECKOUT_PRO = 'https://academiaholisticaargentina.com/cart/48966318555386:1';
const CHECKOUT_COMBO = 'https://academiaholisticaargentina.com/cart/48966334808314:1';
type Product = {
  emoji: string;
  title: string;
  subtitle: string;
  features: string[];
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  ctaLabel: string;
  badge?: string;
  featured?: boolean;
};
const PRODUCTS: Product[] = [{
  emoji: '🌟',
  title: 'COMBO HOLÍSTICO',
  subtitle: 'Maestría Reiki + Biodecodificación Integral',
  features: ['Todo el MegaPack Maestría Reiki', 'Biodecodificación Integral completa', 'Doble certificación oficial', 'El camino holístico más completo'],
  oldPrice: '$110.000',
  price: '$31.990',
  checkoutUrl: CHECKOUT_COMBO,
  ctaLabel: '→ QUIERO EL COMBO HOLÍSTICO',
  badge: '⭐ MÁS COMPLETO',
  featured: true
}, {
  emoji: '🏆',
  title: 'MAESTRÍA + KIT PROFESIONAL',
  subtitle: '6 Tomos + 6 Bonos + Kit Profesional',
  features: ['Todo lo del MegaPack Maestría', 'Kit Reiki Profesional incluido', 'Material para formar alumnos', 'Certificado profesional'],
  oldPrice: '$89.000',
  price: '$27.990',
  checkoutUrl: CHECKOUT_PRO,
  ctaLabel: '→ QUIERO MAESTRÍA + KIT PRO',
  badge: '🎯 RECOMENDADO'
}, {
  emoji: '📘',
  title: 'MEGAPACK MAESTRÍA REIKI',
  subtitle: '6 Tomos + 6 Bonos · Niveles I, II y Maestría',
  features: ['Formación completa desde cero', 'Certificado oficial incluido', 'Acceso de por vida', '100% Online y a tu ritmo'],
  oldPrice: '$69.000',
  price: '$19.990',
  checkoutUrl: CHECKOUT_BASE,
  ctaLabel: '→ QUIERO EL MEGAPACK'
}];
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-4 sm:px-6 relative overflow-hidden border-t border-[#e8d5f0]" data-id="element-318">
      <div className="container mx-auto max-w-4xl" data-id="element-319">
        <div ref={ref1} className={`reveal text-center mb-8 md:mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-320">
          <span className="text-[#c9a14d] text-[10px] sm:text-xs font-bold tracking-[0.25em] uppercase mb-2 block" data-id="element-321">
            🪷 Oferta de relanzamiento
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-3 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-322">
            Elegí Tu Camino
          </h2>
          <p className="text-[#6b5a85] text-sm md:text-base max-w-xl mx-auto" data-id="element-323">
            3 caminos disponibles. Acceso inmediato y de por vida. Sin
            suscripciones.
          </p>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal space-y-4 md:space-y-5 ${vis2 ? 'is-visible' : ''}`} data-id="element-324">
          {PRODUCTS.map((p, idx) => <div key={idx} className={`relative bg-white rounded-xl md:rounded-2xl overflow-hidden transition-all ${p.featured ? 'border-2 border-[#c9a14d] shadow-[0_15px_40px_rgba(201,161,77,0.2)]' : 'border border-[#e8d5f0] shadow-sm hover:shadow-md'}`} data-id="element-325">
              {p.badge && <div className="absolute top-3 right-3 z-10" data-id="element-326">
                  <span className={`text-[9px] sm:text-[10px] font-bold px-2.5 py-1 rounded-full shadow-sm whitespace-nowrap uppercase tracking-wider ${p.featured ? 'bg-gradient-to-r from-[#c9a14d] to-[#b8945a] text-white' : 'bg-[#3d2a5f] text-white'}`} data-id="element-327">
                    {p.badge}
                  </span>
                </div>}

              <div className="flex flex-col sm:flex-row items-stretch" data-id="element-328">
                {/* LEFT: Info + Features */}
                <div className="flex-1 p-4 sm:p-5 md:p-6 sm:border-r border-[#e8d5f0]" data-id="element-329">
                  <div className="flex items-start gap-2 mb-2 pr-20 sm:pr-0" data-id="element-330">
                    <span className="text-2xl sm:text-3xl leading-none flex-shrink-0" data-id="element-331">
                      {p.emoji}
                    </span>
                    <div className="min-w-0" data-id="element-332">
                      <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#3d2a5f] leading-tight" style={{
                    fontFamily: "'Playfair Display', serif"
                  }} data-id="element-333">
                        {p.title}
                      </h3>
                      <p className={`font-semibold text-[11px] sm:text-xs leading-tight mt-1 ${p.featured ? 'text-[#c9a14d]' : 'text-[#6b5a85]'}`} data-id="element-334">
                        {p.subtitle}
                      </p>
                    </div>
                  </div>

                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5 mt-3 text-[11px] sm:text-xs text-[#3d2a5f] font-medium" data-id="element-335">
                    {p.features.map((f, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-336">
                        <CheckIcon className="w-3.5 h-3.5 text-[#c9a14d] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-337" />
                        <span data-id="element-338">{f}</span>
                      </li>)}
                  </ul>
                </div>

                {/* RIGHT: Price + CTA */}
                <div className={`flex flex-row sm:flex-col items-center sm:items-stretch sm:justify-center gap-3 sm:gap-2 p-4 sm:p-5 md:p-6 sm:min-w-[200px] md:min-w-[230px] ${p.featured ? 'bg-[#faf5fc]' : 'bg-[#faf5fc]/60'}`} data-id="element-339">
                  <div className="text-center flex-1 sm:flex-none" data-id="element-340">
                    <p className="text-[#6b5a85] text-[10px] sm:text-xs line-through leading-none mb-1" data-id="element-341">
                      {p.oldPrice}
                    </p>
                    <p className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#3d2a5f] leading-none" data-id="element-342">
                      {p.price}
                    </p>
                    <p className="text-[10px] sm:text-xs font-bold text-[#6b5a85] mt-0.5" data-id="element-343">
                      ARS
                    </p>
                  </div>
                  <a href={p.checkoutUrl} target="_blank" rel="noopener noreferrer" className={`block px-3 py-2.5 sm:py-3 rounded-lg font-bold text-[10px] sm:text-xs tracking-wider uppercase text-center transition-all hover:-translate-y-0.5 flex-1 sm:flex-none whitespace-nowrap ${p.featured ? 'text-white bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] shadow-[0_8px_20px_rgba(201,161,77,0.4)] hover:shadow-[0_12px_30px_rgba(201,161,77,0.5)]' : 'text-[#3d2a5f] bg-white border-2 border-[#3d2a5f]/20 hover:border-[#3d2a5f]/40 hover:bg-[#faf5fc]'}`} style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: '0.03em'
              }} data-id="element-344">
                    {p.ctaLabel}
                  </a>
                </div>
              </div>
            </div>)}
        </div>

        <p className="text-center text-[#6b5a85] text-[10px] sm:text-xs mt-6 flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-345">
          <span data-id="element-346">🛡️ Garantía 7 días</span>
          <span data-id="element-347">•</span>
          <span data-id="element-348">🔒 Pago seguro</span>
          <span data-id="element-349">•</span>
          <span data-id="element-350">💳 Mercado Pago</span>
        </p>
      </div>
    </section>;
}